import type { IndividualPaymentHeaderViewModel } from '@/shared/api/generated';
import { useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader } from '@/shared/api/generated';

/**
 * Cabeçalho de um contrato financeiro — dados do aluno, do curso e os totais
 * que alimentam a régua de indicadores da tela de parcelas.
 *
 * A query fica desabilitada enquanto o `financialPersonId` não for um número
 * válido, para não disparar uma request com `NaN` na URL quando o parâmetro de
 * rota vier corrompido.
 *
 * @param financialPersonId - ID do contrato financeiro; `null` quando o
 *   parâmetro de rota não é um número válido.
 *
 * @example
 * ```tsx
 * const { header, isLoading, isError, refetch } = useIndividualPaymentHeader(101);
 * ```
 */
export function useIndividualPaymentHeader(financialPersonId: number | null) {
  const { data, isLoading, isError, refetch } =
    useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidHeader(
      financialPersonId ?? 0,
      undefined,
      { query: { enabled: financialPersonId !== null } },
    );

  const header: IndividualPaymentHeaderViewModel | undefined = data ?? undefined;

  return {
    header,
    isLoading: financialPersonId !== null && isLoading,
    isError,
    refetch,
  } as const;
}
